import Install from "@/managers/system/install"
import {when} from "@/store/store"
import {sleep} from "@/utility/actions/timing"
import Configuration from "@/managers/system/configuration"
import Notifications from "@/managers/session/notifications"

export async function OfflineHandledCall<T>(createCall: () => Promise<T>, retryCount: number = 1): Promise<T> {
	if (Install.isOffline)
		await Promise.any([when(() => !Install.isOffline), sleep(Configuration.general.offlineWaitTimeout)])

	try {
		return await createCall()
	} catch (error: any) {
		Notifications?.debug(`OfflineHandledCall failed: ${error.message}, retries remaining: ${retryCount}`)

		if (retryCount <= 0 || !(error instanceof TypeError))
			throw error

		if (!Install.isOffline)
			await sleep(Configuration.general.offlineWaitTimeout)

		Notifications?.debug(`OfflineHandledCall retrying`)
		return OfflineHandledCall(createCall, retryCount--)
	}
}
